var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.804688 13.4766C0.804688 13.4766 0.946687 15.2146 0.979687 15.7626C1.02369 16.4976 1.30769 17.3186 1.78169 17.8886C2.45069 18.6966 3.23869 18.9816 4.29069 18.9836C5.52769 18.9856 14.5227 18.9856 15.7597 18.9836C16.8117 18.9816 17.5997 18.6966 18.2687 17.8886C18.7427 17.3186 19.0267 16.4976 19.0717 15.7626C19.1037 15.2146 19.2457 13.4766 19.2457 13.4766",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.329V2.958C6.5 1.738 7.488 0.75 8.708 0.75H11.29C12.509 0.75 13.498 1.738 13.498 2.958L13.499 3.329",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99219 14.6768V13.3828",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 6.39003V9.85703C2.668 11.122 4.966 12.008 7.488 12.359C7.79 11.258 8.783 10.451 9.99 10.451C11.178 10.451 12.191 11.258 12.473 12.369C15.005 12.018 17.312 11.132 19.24 9.85703V6.39003C19.24 4.69603 17.877 3.33203 16.183 3.33203H3.817C2.123 3.33203 0.75 4.69603 0.75 6.39003Z",
    stroke: "#68768B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.ee829fd7b701c16f601448ede4c69014.svg";
export { ForwardRef as ReactComponent };